export const ID = 'a6a53251-15cf-4511-9de1-494dde70defe';

export const NAME = 'StorageMart Combined Header';
